import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { UserToken } from '@app/_models';
import { SelectionService } from './selection.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserTokenSubject: BehaviorSubject<UserToken>;
    public currentUserToken: Observable<UserToken>;

    constructor(private http: HttpClient, private selectionService: SelectionService) {
        this.currentUserTokenSubject = new BehaviorSubject<UserToken>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUserToken = this.currentUserTokenSubject.asObservable();
    }

    public get currentUserTokenValue(): UserToken {
        return this.currentUserTokenSubject.value;
    }

    login(username: string, password: string) {
        return this.http.post<any>(`${environment.apiUrl}/api/auth/login`, { username, password })
            .pipe(map(userToken => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                this.saveUser(userToken);
                return userToken;
            }));
    }

    private saveUser(user: UserToken) {
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserTokenSubject.next(user);
    }

    refreshToken() {
        var user = this.currentUserTokenSubject.value;
        if (user) {
            return this.http.post<any>(`${environment.apiUrl}/api/auth/refreshtoken`, { accessToken: user.accessToken.token, refreshToken: user.refreshToken })
                .pipe(map(userToken => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    this.saveUser(userToken);
                    return userToken;
                }));
        }
        else {
            return null;
        }
    }

    logout() {
        this.selectionService.clearSelection();
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserTokenSubject.next(null);
    }
}